module.exports = __webpack_public_path__ + "img/file-icon_xls.40613d39.svg";